export default __webpack_public_path__ + "static/media/gallery8.4d46dd47.jpeg";